function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m11.3334 4h2c1.1046 0 2 .89543 2 2v6.6667c0 1.1045-.8954 2-2 2h-10.66665c-1.10457 0-2.000002-.8955-2.000002-2v-6.6667c0-1.10457.895432-2 2.000002-2h2c0-1.10457.89543-2 2-2h2.66666c1.10459 0 1.99999.89543 1.99999 2zm-6.99999 1.33333v7.99997h7.33329v-7.99997zm8.66669 0v7.99997h.3333c.3682 0 .6667-.2984.6667-.6666v-6.6667c0-.36819-.2985-.66667-.6667-.66667zm-10.33335 0h.33333v7.99997h-.33333c-.36819 0-.66667-.2984-.66667-.6666v-6.6667c0-.36819.29848-.66667.66667-.66667zm7.33335-1.33333c0-.36819-.2985-.66667-.66669-.66667h-2.66666c-.36819 0-.66667.29848-.66667.66667z",
  fillRule: "evenodd"
});

var SvgBriefcase = function SvgBriefcase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBriefcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/briefcase.de51d8d1.svg";
export { ForwardRef as ReactComponent };